import React, { useReducer, createContext } from 'react';
import { createContainer } from 'react-tracked';

export const CharacterLiveStateContext = createContext(null);

export const CHARACTER_STATE_KEYS = {
  character: true,
  displayName: true,
  interactionId: true,
  id: true,
  micOn: true,
  webcamOn: true,
  webcamStream: true,
  micStream: true,
  characterState: true,
  characterMode: true,
  characterRole: true,
  knowledgeBases: true,
  language: true,
  metaData: true,
  isActiveSpeaker: true
};

export const EMPTY_CHARACTER_STATE = {
  character: null,
  displayName: undefined,
  interactionId: undefined,
  id: undefined,
  micOn: false,
  webcamOn: false,
  webcamStream: null,
  micStream: null,
  characterState: null,
  characterMode: undefined,
  characterRole: undefined,
  knowledgeBases: undefined,
  language: undefined,
  metaData: undefined,
  isActiveSpeaker: false
};

// State shape: { [characterId]: CharacterData }
const reducer = (state, action) => {
  if (action === 'RESET') return {};

  const { type, id, data } = action;

  switch (type) {
    case 'INIT': {
      return {
        ...state,
        [id]: { ...EMPTY_CHARACTER_STATE, ...data }
      };
    }

    case 'REMOVE': {
      const { [id]: _, ...rest } = state;
      return rest;
    }

    case 'UPDATE': {
      const prev = state[id];
      if (!prev) return state;

      // Bail out if nothing actually changed
      const hasChange = Object.keys(data).some(k => prev[k] !== data[k]);
      if (!hasChange) return state;

      return { ...state, [id]: { ...prev, ...data } };
    }

    default:
      return state;
  }
};

const {
  Provider: CharacterStateProviderBase,
  useTrackedState: useCharacterTrackedState,
  useSelector: useCharacterSelector,
  useUpdate: useCharacterDispatch
} = createContainer(() => useReducer(reducer, {}));

export const CharacterStateProvider = ({ children }) => (
  <CharacterStateProviderBase>{children}</CharacterStateProviderBase>
);

export { useCharacterTrackedState, useCharacterSelector, useCharacterDispatch };
